// @owners { team: patients }
import { setColors, setFonts } from '@alto/design-library-tokens';
import { LoadingEmptyState } from '@alto/design-system';
import React, { useEffect, useState } from 'react';
import { loadImages, setImages } from '~shared/assets/images/getImage';

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [isReady, setIsReady] = useState(false);

  // Keep the token store in sync for components importing COLORS. Post-rebrand there is a single
  // brand (FuzeRx), so this only loads the brand chunks once — no host/flag resolution involved.
  useEffect(() => {
    const applyBrand = async () => {
      const [{ FUZERX_COLORS, FUZERX_FONTS }, images] = await Promise.all([
        // webpack: /* webpackChunkName: "brand-fuzerx" */
        import('@alto/design-library-tokens'),
        loadImages(),
      ]);

      setColors(FUZERX_COLORS);
      setFonts(FUZERX_FONTS);
      setImages(images);
      setIsReady(true);
    };

    applyBrand();
  }, []);

  if (!isReady) {
    return <LoadingEmptyState />;
  }

  return <div>{children}</div>;
}
